import { useState } from 'react';
import { React } from 'Imports';
import { Box, Button, Modal, Paper, ThemeProvider, createTheme } from '@mui/material';
import { isEncompass } from '$Utilities/integrationPlatform';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/pro-solid-svg-icons';
import SingleSelectDropdownMenu from '$Components/Shared/Dropdown/SingleSelectDropdownMenu';
import { AssignDriverToEventsRequest } from '$Generated/api';
import { IDriver } from './VideoEventListMultiSelect';
import { StyledBulkCancelButton, StyledBulkAssignButton } from './VideoEventListStyles';

type Styles = {
    modal: string;
    modalEncompass: string;
    modalTitleBar: string;
    modalTitleBarEncompass: string;
    modalBody: string;
    modalBodyEncompass: string;
    modalButtonGroup: string;
    modalButtonGroupEncompass: string;
    button: string;
    buttonEncompass: string;
    cancelButton: string;
    cancelButtonEncompass: string;
};

const styles = require('./VideoEventListBulkAssignModal.scss') as Styles;

interface IVideoEventListBulkAssignModalProps {
    open: boolean;
    onClose: () => void;
    selectedEventsCount: number;
    activeDrivers: IDriver[];
    getSelectedEvents: () => Promise<number[]>;
    bulkAssignFn: (req: AssignDriverToEventsRequest) => Promise<boolean>;
}

const VideoEventListBulkAssignModal = (props: IVideoEventListBulkAssignModalProps) => {
    const [selectedDriver, setSelectedDriver] = useState<IDriver | undefined>(undefined);
    const [searchFilter, setSearchFilter] = useState('');
    const [dropdownIsOpen, setDropdownIsOpen] = useState(false);

    const drivers = props.activeDrivers.map((driver) => {
        return {
            label: driver.firstName + ' ' + driver.lastName,
            value: driver.driverId ?? '',
            onClick: () => {
                setSelectedDriver(driver);
                handleDropdownClose();
            },
        };
    });

    const handleModalClose = () => {
        props.onClose();
        setDropdownIsOpen(false);
        setSelectedDriver(undefined);
    };

    const handleDropdownOpen = () => {
        setDropdownIsOpen(true);
        setSearchFilter('');
    };

    const handleDropdownClose = () => {
        setDropdownIsOpen(false);
        setSearchFilter('');
    };

    const handleSubmit = async () => {
        handleModalClose();
        const videoEventIds = await props.getSelectedEvents();
        const request = {
            ...selectedDriver,
            videoEventIdList: videoEventIds,
        };

        await props.bulkAssignFn(request);
    };

    return (
        <Modal open={props.open} onClose={handleModalClose}>
            <Paper className={isEncompass ? styles.modalEncompass : styles.modal}>
                <Box className={isEncompass ? styles.modalTitleBarEncompass : styles.modalTitleBar}>
                    <Box>
                        Assign Driver to {props.selectedEventsCount} {props.selectedEventsCount === 1 ? 'Event' : 'Events'}
                    </Box>
                    <FontAwesomeIcon
                        icon={faXmark}
                        onClick={handleModalClose}
                        size={'sm'}
                        style={{ cursor: 'pointer', color: isEncompass ? '#373E40' : '#8DA4B9' }}
                        color={isEncompass ? '#373E40' : '#8DA4B9'}
                    />
                </Box>
                <Box className={isEncompass ? styles.modalBodyEncompass : styles.modalBody}>
                    <SingleSelectDropdownMenu
                        open={dropdownIsOpen}
                        onOpen={handleDropdownOpen}
                        onClose={handleDropdownClose}
                        items={drivers}
                        searchProps={{
                            searchable: true,
                            searchFilter: searchFilter,
                            onChange: (value: string) => setSearchFilter(value),
                            placeholder: isEncompass ? 'Enter Search Term ...' : 'Search ...',
                            hideAdornments: true,
                        }}
                        label={'Select Driver'}
                        required
                    />
                </Box>
                <Box className={isEncompass ? styles.modalButtonGroupEncompass : styles.modalButtonGroup}>
                    <StyledBulkCancelButton onClick={handleModalClose}>Cancel</StyledBulkCancelButton>
                    <StyledBulkAssignButton onClick={handleSubmit} disabled={selectedDriver === undefined}>
                        Assign
                    </StyledBulkAssignButton>
                </Box>
            </Paper>
        </Modal>
    );
};

export default VideoEventListBulkAssignModal;
